import React from 'react'

const SortButton = ({sortType}) => {
  return (
    <div style={{display: 'flex', alignItems: 'center', gap: 1}}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={10}
        height={12}
        fill="none"
      >
        <path
          fill={sortType === 'asc' ? '#333945' : '#808F94'}
          d="M4.7 0a.647.647 0 0 0-.672.68v7.477l.047 1.308-1.57-1.75-1.381-1.37a.678.678 0 0 0-.73-.152A.637.637 0 0 0 0 6.8a.668.668 0 0 0 .21.49l3.99 3.998a.7.7 0 0 0 1 0l3.986-4A.668.668 0 0 0 9.4 6.8a.632.632 0 0 0-.642-.66.681.681 0 0 0-.485.2L6.9 7.715 5.323 9.47l.054-1.314V.675A.65.65 0 0 0 4.7 0Z"
          opacity={sortType === 'asc' ? 1 : 0.6}
        />
      </svg>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={10}
        height={12}
        fill="none"
        style={{transform: 'rotate(180deg)'}}
      >
        <path
          fill={sortType === 'desc' ? '#333945' : '#808F94'}
          d="M4.7 0a.647.647 0 0 0-.672.68v7.477l.047 1.308-1.57-1.75-1.381-1.37a.678.678 0 0 0-.73-.152A.637.637 0 0 0 0 6.8a.668.668 0 0 0 .21.49l3.99 3.998a.7.7 0 0 0 1 0l3.986-4A.668.668 0 0 0 9.4 6.8a.632.632 0 0 0-.642-.66.681.681 0 0 0-.485.2L6.9 7.715 5.323 9.47l.054-1.314V.675A.65.65 0 0 0 4.7 0Z"
          opacity={sortType === 'desc' ? 1 : 0.6}
        />
      </svg>
    </div>
  )
}

export default SortButton
